import {createTheme} from '@mui/material/styles';


export const theme = createTheme({

    palette: {
        primary: {
            main: "#0B272A",
            light: '#fffff',
        },
        secondary: {
            main: "#fff",
        },
        info: {
            main: "#A47F4A",
        },
        success: {
            main: "#818181"
        },
        action: {
            main: "#FFF"
        },
        warning: {
            main: '#fa896b'
        }

    },
    typography: {
        fontFamily: ['Raleway', 'Roboto', 'sans-serif'].join(','),
    },
    components: {
        MuiGrid: {
            styleOverrides: {
                root: {
                    transition: "all .2s ease-in-out"
                }
            }
        },
        MuiTextField: {
            defaultProps: {
                fullWidth: true,
                variant: "filled",
                size: "medium"
            }
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    paddingLeft: 10,
                    paddingRight: 10,
                    borderRadius: 6
                }
            }
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    paddingLeft: 10
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 6
                }
            }
        },
        MuiButtonBase: {
            variants: [
                {
                    props: {variant: 'efecto'},
                    style: {
                        transition: 'all .1s ease-in-out',
                        borderRadius: 10,
                        '&: hover': {
                            marginTop: -6,
                            boxShadow: "0px 0px 0px 0px rgba(0,0,0,0)",

                        }
                    },
                },


            ],

        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 8
                }
            }
        },
        MuiButton: {
            defaultProps: {
                variant: "outlined",
                color: 'secondary',

            },
            styleOverrides: {
                root: {
                    borderRadius: 40,
                    fontWeight: 600,
                    paddingLeft: 40,
                    paddingRight: 40,
                    fontSize: 16,
                    paddingTop: 16,
                    paddingBottom: 14

                },

            }
        },
        MuiDrawer: {
            styleOverrides: {

                paper: {
                    backgroundColor: '#0B272A'
                }
            }
        }


    }


})
